import React from 'react';
import { useNavigate } from 'react-router-dom';
// The original wordmark is white — invisible on the light navbar.
import fleekLogo from '../assets/fleek-dark.png';
import BrandLogo from './BrandLogo';
import { usePortalConfig } from '../utils/portalConfig';
import { hostedPartnerLogo } from '../utils/partnerLogos';

/**
 * Co-branded bar, partner-led.
 *
 * These are the partner's members on the partner's programme, so the partner
 * owns the bar and Fleek signs it — the white-label convention. Fleek used to
 * lead with the partner tucked in the corner, which read as a Fleek site.
 */
const Navbar = () => {
  const navigate = useNavigate();
  const portalConfig = usePortalConfig();

  const hosted = hostedPartnerLogo();
  const partnerName = portalConfig?.display_name || hosted?.name;
  const configuredLogo = portalConfig?.display_logo_url;

  /* Logo fallback chain: configured URL → our hosted copy → the partner's
     name. The name, not an initial — this is the headline mark on the page. */
  const wordmark = partnerName ? (
    <span className="navPartnerWordmark">{partnerName}</span>
  ) : null;

  const hostedMark = hosted ? (
    <BrandLogo
      className="navPartnerLogo"
      src={hosted.src}
      name={partnerName}
      alt={`${partnerName} logo`}
      fallback={wordmark}
      loading="eager"
    />
  ) : (
    wordmark
  );

  const partnerMark = configuredLogo ? (
    <BrandLogo
      className="navPartnerLogo"
      src={configuredLogo}
      name={partnerName}
      alt={`${partnerName || 'Partner'} logo`}
      fallback={hostedMark}
      loading="eager"
    />
  ) : (
    hostedMark
  );

  return (
    <nav className="nav">
      <div className="navInner">
        <button
          type="button"
          className="navBrand"
          onClick={() => navigate('/marketplace')}
          aria-label={partnerName ? `${partnerName} rewards — home` : 'Home'}
        >
          {partnerMark}
        </button>

        <div className="navPoweredBy">
          <span className="navPoweredByLabel">Powered by</span>
          <img className="navLogo" src={fleekLogo} alt="Fleek" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
